import PropTypes from 'prop-types';
import React from 'react';

import { makeStyles } from '@material-ui/core';
import CircularProgess from '@material-ui/core/CircularProgress'

import './Arrow.css';

const useProgressStyles = makeStyles(() => ({
  root: {
    display: 'inline-block',
    width: '21px !important',
    height: '21px !important',
    color: '#f8f8f8'
  }
}))

export const Arrow = ({loading, type, ...props}) => {
  const classes = useProgressStyles();
  return (
    <button className="Arrow" type={type} {...props}>
      {loading
        ? <CircularProgess className={classes.root} />
        : <span className="Arrow-arrow" />
      }
    </button>
  )
};

Arrow.propTypes = {
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  type: PropTypes.string
};

Arrow.defaultProps = {
  onClick: () => { },
  loading: false,
  type: 'button'
};

export default Arrow;
